import { render, staticRenderFns } from "./freightPrice.vue?vue&type=template&id=01266c87&"
import script from "./freightPrice.vue?vue&type=script&lang=js&"
export * from "./freightPrice.vue?vue&type=script&lang=js&"
import style0 from "./freightPrice.vue?vue&type=style&index=0&id=01266c87&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports